
import Transformer from './../transformer'

export default class SupplyValidationTransformers extends Transformer {
  static fetch({unit_measurement: unitMeasurement,
                are_validation: areValidation,
                are_validation_date: areValidationDate,
                purchase_validation: purchaseValidation,
                purchase_validation_date: purchaseValidationDate,
                ...supply}) {
    return {
      ...supply,
      unitMeasurement,
      areValidation,
      areValidationDate,
      purchaseValidation,
      purchaseValidationDate,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/supplyValidation.js